import React from 'react';
import { Reveal } from './Reveal';
const stats = [['6', 'COMPLETE BOOKS'], ['360+', 'PAGES OF CONTENT'], ['100+', 'READY LESSONS'], ['100%', 'NO-PREP']];
export function StatsBar() {
  return <section className="border-y border-brand-dark bg-brand-alt py-8" data-id="element-149" data-mp="1oalz3d3o14cb">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-150" data-mp="1jcanawtt8jrg">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-dark' : ''}`} data-id="element-151" data-mp="1ee0rql46bh5b" data-mpi={index}>
          <span className="mb-1 font-serif text-3xl font-bold text-brand-blue md:text-4xl" data-id="element-152" data-mp="19ko9qtu028lj">{value}</span>
          <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-153" data-mp="10lt1zdbb4qg4">{label}</span>
        </div>)}
      </Reveal>
    </section>;
}